import React from 'react';
import { NavLink } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import RestaurantIcon from '@material-ui/icons/Restaurant';
const WholeCode = (props) => {
    return (
        <>
            <div className="maindiv" className={props.topHomepageclass} id={props.topDishesclass}>
                <header className="container-fluid " >
                    <div className="container text-center">
                        <h1 className="display-4 text-white" style={{ paddingTop: "120px", filter: "Brightness(100%)", color: "white", fontSize: "36px" }} >{props.mainHeading}</h1>
                        <p className="text-white lead pb-4" style={{ borderRadius: "30px", position: "relative" }}>{props.belowParagraph}</p>
                        <a href="/topdishes" className="btn btn-primary btn-md" role="button" style={{ marginTop: "-20px", borderRadius: "30px", position: "relative" }}>{props.btn}</a>
                    </div>
                </header>
            </div>
            <div className="card-body card-body-cascade text-center" style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", position: "relative", marginTop: "190px"  }}>
                <h4 className="card-title"><strong>{props.cardHeading}</strong></h4>
                <h6 className="font-weight-bold indigo-text py-2">{props.cardBelowHeading}</h6>
                <p className="card-text">{props.cardParagraph}</p>
                <a className="px-2 fa-lg li-ic"><i className="fab fa-linkedin-in"><LinkedInIcon /></i></a>
                <a className="px-2 fa-lg tw-ic"><i className="fab fa-twitter"><TwitterIcon /></i></a>
                <a className="px-2 fa-lg fb-ic"><i className="fab fa-facebook-f"><FacebookIcon /></i></a>
            </div>
            <br></br>
            <br></br>
        </>
    )
}

//Navbar Component
const NavbarComponent = () => {
    return (
        <>
            <nav className="navbar-expand-lg navbar navbar-light bg-lignt" style={{ padding: "30px", textDecoration: "none", color: "black", background: "smokyBlack", background: "transparent" }}>
                <NavLink exact to="/" className="navbar-brand" style={{ paddingLeft: "140px", textDecoration: "none", color: "black" }}>Food Product</NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar">
                    <span className="navbar-toggler-icon my-toggler"></span>
                </button>
                <div className="navbar-collapse collapse" id="navbar">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item active">
                            <NavLink exact to="/topdishes" className="nav-link" style={{ textDecoration: "none", color: "black" }}>Top Dishes
                <span className="sr-only">(current)</span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact to="/fooddishes" className="nav-link" style={{ textDecoration: "none", color: "black" }}>Foods Dishes</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink exact to="/vegetables" className="nav-link" style={{ textDecoration: "none", color: "black" }}>Vegetables</NavLink>
                        </li>
                    </ul>
                    <ul className="navbar-nav ml-auto nav-flex-icons">
                        <li className="nav-item">
                        </li>
                        <li className="nav-item" >
                        </li>
                    </ul>
                    <form className="form-inline">
                        <div className="md-form my-0">
                            <input className="form-control mr-sm-2 bg-white border-0" type="text" placeholder="Search" aria-label="Search" style={{ outline: "none", outlineColor: "white", outlineOffset: "0ch" }} />
                        </div>
                    </form>
                </div>
            </nav>
        </>
    )
}

//Navbar Component
const WebsiteFooter = () => {
    return (
        <>
            <footer className="page-footer font-small stylish-color-dark bg-dark text-white pt-4">
                <div className="container text-center text-md-left">
                    <div className="row">
                        <div className="col-md-4 mx-auto">
                            <h5 className="font-weight-bold text-uppercase mt-3 mb-4">Food Recipe</h5>
                            <p>Live on you, Collin Street Bakery has been baking the world’s best fruitcake since 1896? That’s right! Our world-famous Pro DeLuxe®</p>
                        </div>
                        <hr className="clearfix w-100 d-md-none" />
                        <div className="col-md-2 mx-auto">
                            <h5 className="font-weight-bold text-uppercase mt-3 mb-4">Dishes</h5>
                            <ul className="list-unstyled">
                                <li>
                                    <NavLink exact to="/topdishes" className="text-white">Top Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/fooddishes" className="text-white">Food Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/vegetables" className="text-white">Vegetables</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/" className="text-white">Food Recipe</NavLink>
                                </li>
                            </ul>

                        </div>


                        <hr className="clearfix w-100 d-md-none"></hr>


                        <div className="col-md-2 mx-auto">


                            <h5 className="font-weight-bold text-uppercase mt-3 mb-4">Top Dishes</h5>

                            <ul className="list-unstyled">
                                <li>
                                    <NavLink exact to="/topdishes" className="text-white">Top Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/fooddishes" className="text-white">Food Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/vegetables" className="text-white">Vegetables</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/" className="text-white">Food Recipe</NavLink>
                                </li>
                            </ul>

                        </div>

                        <hr className="clearfix w-100 d-md-none"></hr>
                        <div className="col-md-2 mx-auto">
                            <h5 className="font-weight-bold text-uppercase mt-3 mb-4">Links</h5>
                            <ul className="list-unstyled">
                                <li>
                                    <NavLink exact to="/topdishes" className="text-white">Top Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/fooddishes" className="text-white">Food Dishes</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/vegetables" className="text-white">Vegetables</NavLink>
                                </li>
                                <li>
                                    <NavLink exact to="/" className="text-white">Food Recipe</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <hr></hr>


                <ul className="list-unstyled list-inline text-center">
                    <li className="list-inline-item">
                        <a href="https://www.facebook.com/irfoMIB" className="btn-floating btn-fb mx-1 text-white">
                            <i className="fab fa-facebook-f"> <FacebookIcon /> </i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a href="https://twitter.com/M_irfan288" className="btn-floating btn-tw mx-1 text-white">
                            <i className="fab fa-twitter"> <TwitterIcon /> </i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a href="https://www.linkedin.com/in/muhammad-irfan-26474317b/" className="btn-floating btn-gplus mx-1 text-white">
                            <i className="fab fa-google-plus-g"> <LinkedInIcon /> </i>
                        </a>
                    </li>
                    <li className="list-inline-item">
                        <a href="https://www.instagram.com/" className="btn-floating btn-li mx-1 text-white">
                            <i className="fab fa-linkedin-in"> <InstagramIcon /> </i>
                        </a>
                    </li>
                </ul>
                <div className="footer-copyright text-center py-3">© 2020 Copyright :
                 <a href="http://irfanofficial.ml" className="text-white pl-2">
                        Irfan Official
                  </a>
                </div>
            </footer>
        </>
    )
}
const FoodDishesPage = (props) => {
    return (
        <>
            <div className="row" id="fooddishesPic">
                <div className="col-md-12 mb-3" >
                    {/* <img src={props.FoodDishesComponentImgSrc} alt="Responsive image" className="firstImgDishes" style={{ width: "100%" }} /> */}
                </div>
            </div>
            <div className="row left_section" style={{ marginTop: "20px" }}>
                <div className="col-lg-4 col-md-12 mb-3">
                    <img src={props.foodDishesImgSrc1} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                    <img src={props.foodDishesImgSrc2} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                    <img src={props.foodDishesImgSrc3} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
            </div>
            <div className="row left_section">
                <div className="col-lg-4 col-md-12 mb-3">
                    <img src={props.foodDishesImgSrc4} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                    <img src={props.foodDishesImgSrc5} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
                <div className="col-lg-4 col-md-6 mb-3">
                    <img src={props.foodDishesImgSrc6} className="img-fluid z-depth-1 firstImg"
                        alt="Responsive image" />
                </div>
            </div>
        </>
    )
}

const CardDetailsPage = (props) => {
    return (
        <>
            <div className="card card-cascade wider reverse d-5 left_section" style={{ marginTop: "50px", boxShadow: "10px 10px 5px rgba(0.6,0,0,0.6)", margin: "150px" }}>
                <div className="view view-cascade overlay">
                    <img className="card-img-top" src={props.imgChoostSrc} alt="Card image cap" style={{ height: "400px" }} />
                    <a href="#!">
                        <div className="mask rgba-white-slight"></div>
                    </a>
                </div>
                <div className="card-body card-body-cascade text-center">
                    <h5 className="pink-text pb-2 pt-1" style={{ color: "red", fontSize: "20px" }}><i className="fas fa-utensils"></i><RestaurantIcon /> Culinary</h5>
                    <h4 className="card-title"><strong>{props.title}</strong></h4>
                    <p className="card-text">{props.choostSeezParagraph}</p>
                    <a href={props.Orderbtn} className="btn btn-outline-primary btn-sm" style={{ borderRadius: "30px" }}>{props.OrderbtnTitle}</a>
                    <br></br>
                    <br></br>
                </div>
            </div>
            <br></br>
            <br></br>
        </>
    )
}
export default WholeCode;
export { NavbarComponent, WebsiteFooter, FoodDishesPage, CardDetailsPage };